// extracted by mini-css-extract-plugin
export default {"display":"Setting_display__D64oe","buttonArea":"Setting_buttonArea__5oGyd"};